<template>
  <div class id="orderConfirm">
    <van-image width="100%" height="45%" fit="cover" :src="carData.images[0].imgPath" />
    <div class="infoBox">
      <div class="box">
        <div class="title">
          <h1>{{ carData.carModelName }}</h1>
        </div>
        <div class="money">
          <span>
            成交价:
            <em>{{ carData.price }}</em>
          </span>
        </div>
        <van-field required label="客户姓名" v-model="resData.userName" placeholder="请输入姓名" />
        <van-field required label="客户电话" v-model="resData.phone" placeholder="请输入电话" />
        <van-field center clearable label="验证码" v-model="resData.code" placeholder="请输入验证码">
          <van-button
            slot="button"
            size="small"
            :disabled="count<60"
            @click="onGetCode"
            plain
            hairline
            type="info"
          >{{count>=60?'获取验证码':count}}</van-button>
        </van-field>
      </div>
      <div class="explain">
        <span>说明：下载APP可跟踪订单状态。并且更多车主服务</span>
      </div>
    </div>
    <div class="btnBox">
      <van-button block @click="onOK" type="info">提交</van-button>
    </div>
  </div>
</template>

<script>
import {
  Swipe,
  SwipeItem,
  Header,
  Cell,
  DatetimePicker,
  Indicator,
  Toast
} from "mint-ui";
import {
  API_GET,
  API_POST,
  getLocation,
  getToken,
  clearToken,
  getUnionId,
  API_POST_JSON,
  getInvitationCode
} from "@/apiConfig";
export default {
  name: "orderConfirm",
  data() {
    return {
      resData: {
        userName: "",
        phone: "",
        code: "",
        identifier: ""
      },
      carData: {},
      count: 60,
      unionId: getUnionId() // 微信浏览器端返回id
    };
  },
  mounted() {
    window.scroll(0, 0);
    this.fetchData();
    this.unionId = getUnionId();
    this.isLogin = getToken() ? true : false;
  },
  methods: {
    fetchData: function() {
      console.log(this.$route.query.orderId);
      let body = {
        orderId: this.$route.query.orderId
      };
      if (body.orderId) {
        this.loading = false;
        API_GET("/lianlianche-car/carBuy/getById", body).then(res => {
          this.loading = true;
          if (res.status == 0) {
            this.carData = res.data;
          } else {
            Toast({
              message: res.msg
            });
          }
        });
      }
    },

    onOK: function() {
      console.log(this.$route.query.orderId);
      let body = {
        orderId: this.$route.query.orderId,
        userName:this.resData.userName,
        phone:this.resData.phone,
        code:this.resData.code
      };
      if (body.orderId) {
        this.loading = false;
        API_POST_JSON("/lianlianche-car/carBuy/confirmOrder", body).then(
          res => {
            this.loading = true;
            if (res.status == 0) {
              console.log(res.data);
              this.resData = res.data;
              Toast({
                message: '提交成功'
              });
            } else {
              Toast({
                message: res.msg
              });
            }
          }
        );
      }
    },

    onGetCode: function() {
      /**
       * 发送验证码
       */
      if (this.resData.phone && this.resData.phone.trim()) {
        API_POST(
          "http://gateway.lianlianche.com:9000/lianlianche-user/welcome/sendMsg",
          { phone: this.resData.phone },
          true
        ).then(res => {
          if (res.status == 0) {
            let time = window.setInterval(() => {
              this.count--;
              if (this.count == 0) {
                time = null;
                this.count = 60;
              }
            }, 1000);
            Toast(`验证码已发送，请注意查收`);
          } else {
            Toast(res);
          }
        });
      } else {
        Toast(`请填写正确的手机号码`);
        return;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/orderConfirm.vue